module.exports = __webpack_public_path__ + "assets/img/button-year.8811c0b7.png";